/* #region header */
/**************************************************************************************************
//
//  Description: Aligned Assets Read Only component
//
//  Copyright:    © 2021-22 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   13.04.21 Sean Flook         WI39345 Initial Revision.
//    002   05.05.21 Sean Flook         WI39345 Tweaks to the UI after design review meeting.
//    003   14.05.21 Sean Flook         WI39345 Updated className.
//    004   19.08.22 Joel Benford       WI40077 Change styling formReadOnly to formReadOnlyText
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
/* #endregion header */

/* #region imports */

import React from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import { Typography } from "@material-ui/core";
import useStyles from "../utils/AAStyles";

/* #endregion imports */

AAReadOnlyControl.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

function AAReadOnlyControl(props) {
  const classes = useStyles();

  return (
    <Grid
      container
      justify="flex-start"
      alignItems="center"
      className={classes.formrow}
    >
      <Grid item xs={4}>
        <Typography variant="body2" align="left" color="textPrimary">
          {props.label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography
          variant="body1"
          align="left"
          color="textPrimary"
          className={classes.formReadOnlyText}
        >
          {props.value}
        </Typography>
      </Grid>
    </Grid>
  );
}

export default AAReadOnlyControl;
